import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './i18n.ts';
import './styles/globals.css';

// Load test utilities in development
if (import.meta.env.DEV) {
  import('./utils/items-test').then(module => {
    (window as any).itemsTestUtils = module.itemsTestUtils;
  });
  import('./utils/items-integration-test').then(module => {
    (window as any).itemsIntegrationTest = module.itemsIntegrationTest;
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
